import { FiCheck, FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import useRootTranslation from "../../../../../../../hooks/use-root-translation";
import { AppState } from "../../../../../../../store/app-state";
import { RemoveButton, TRow, Table } from "./group-table.styled";
import { useCallback } from "react";
import { removeTeamate } from "../../../../../../../store/company-profile/company-profile.actions";
import { useDialog } from "../../../../../../../hooks";
import { BsFillTrashFill } from "react-icons/bs";

const GroupTable: React.FC = () => {
  const { root } = useRootTranslation(
    "company-profile.group-section.group-table-headers",
    "private-home-page"
  );
  const { groupUsers } = useSelector(
    (state: AppState) => state.companyProfileState
  );
  const dispatch = useDispatch();
  const { createDialog } = useDialog();
  const { user } = useSelector((state: AppState) => state.authState);
  
  const confirmRemoveTeamate = useCallback(() => {
    return createDialog({
      title: root("remove-teamate-dialog.title"),
      message: root("remove-teamate-dialog.message"),
      confirmLabel: root("remove-teamate-dialog.confirmLabel"),
      top: 0,
    });
  }, [root, createDialog]);

  const handleRemoveTeamate = useCallback(
    async (id: string) => {
      const confirmed = await confirmRemoveTeamate();
      if (confirmed && user?.corporate.id) {
        dispatch(removeTeamate(id, user.corporate.id));
      }
    },
    [dispatch, confirmRemoveTeamate, user]
  );

  return (
    <Table>
      <TRow>
        <th>{root("name")}</th>
        <th>{root("email")}</th>
        <th>{root("phone")}</th>
        <th className="center">{root("admin")}</th>
        <th className="center">{root("action")}</th>
      </TRow>
      {groupUsers.data?.map((user, index) => (
        <TRow key={`user-${user.id}-${index}`}>
          <td>{user.name}</td>
          <td>{user.email}</td>
          <td>{user.phone}</td>
          <td className="center">
            {user.is_admin ? (
              <FiCheck className="check-icon" />
            ) : (
              <FiX className="cross-icon" />
            )}
          </td>
          <td className="center">
            {!user.is_admin ? (<RemoveButton
              onClick={() => {
                handleRemoveTeamate(user.id);
              }}
            >
              <BsFillTrashFill />
            </RemoveButton>) : null}
          </td>
        </TRow>
      ))}
    </Table>
  );
};

export default GroupTable;